import styled from 'styled-components';

import { Modal } from '@dexma/ui-components';

export const StyledPinDashboardModal = styled(Modal)`
    .server-error-alert {
        margin-bottom: 20px;
    }
    .ant-modal-header {
        border-bottom: none;
    }
`;
